import styled from 'styled-components';

import { Button, CurrencyInput } from '@libs/components';

export const CustomCurrencyInput = styled<any>(CurrencyInput)`
  width: calc(100% + 0.2rem);
  margin: -0.1rem;
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  .currency-select {
    border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  }
  .select-icon {
    max-width: 3.2rem;
    svg {
      width: 3.2rem;
      height: 3.2rem;
    }
  }
  .valueText {
    font-family: ${({ theme }) => theme.fonts.primaryMedium};
    margin-left: 0.4rem;
  }
`;
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  background-color: ${({ theme }) => theme.colors.surface.hover};
`;

export const BalanceSelectorsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 0.8rem;
  padding: 1.6rem 1.2rem;
`;

export const PercentButton = styled(Button)`
  border: 0.5px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.x10};
  padding-top: 0.4rem;
`;
